import { useContext, useState } from 'react';
import {
    Alert,
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Snackbar
} from '@mui/material';

import { USERS_ACTIONS } from 'context/users/userReducer';
import { UserContext } from 'context/users/userContext';
import { Users } from 'lib/api';

const DeactivateUserDialog = () => {
    const {
        state: { user, isDeactivateUserDialogOpen },
        dispatch
    } = useContext(UserContext);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [snackbar, setSnackbar] = useState({
        open: false,
        title: '',
        message: '',
        severity: 'success'
    });

    const handleCancelClick = () => {
        dispatch({ type: USERS_ACTIONS.HIDE_DEACTIVATE_USER_DIALOG });
    };

    const handleDeactivateClick = async () => {
        setIsSubmitting(true);
        try {
            await Users.deactivateUser(user?.id);

            setIsSubmitting(false);
            setSnackbar({
                open: true,
                message: `${user.firstName} ${user.lastName} was deactivated successfully`,
                severity: 'success'
            });
            dispatch({ type: USERS_ACTIONS.HIDE_DEACTIVATE_USER_DIALOG });
            dispatch({ type: USERS_ACTIONS.RELOAD_USERS });
        } catch (error) {
            setIsSubmitting(false);
            setSnackbar({
                open: true,
                message: error?.response?.data?.message || 'An unexpected error ocurred. Please Try again.',
                severity: 'error'
            });
        }
    };

    return (
        <>
            <Dialog open={isDeactivateUserDialogOpen} onClose={() => {}}>
                <DialogTitle sx={{ fontSize: '18px', paddingBottom: '0px' }}>Are you sure you want to deactivate?</DialogTitle>
                <DialogContent>
                    <DialogContentText sx={{ fontSize: '14px' }}>
                        By doing this, {`${user?.firstName} ${user?.lastName}`} won't be able to login to the application. All the
                        cards asigned to {`${user?.firstName} ${user?.lastName}`} will be deactivated automatically.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button variant="outlined" onClick={handleCancelClick}>
                        Cancel
                    </Button>
                    <Button variant="contained" color="error" onClick={handleDeactivateClick} autoFocus>
                        {isSubmitting ? <CircularProgress size="20px" /> : 'Deactivate'}
                    </Button>
                </DialogActions>
            </Dialog>
            <Snackbar
                open={snackbar.open}
                onClose={() => setSnackbar({ ...snackbar, open: false })}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                autoHideDuration={3000}>
                <Alert severity={snackbar.severity} variant="filled" sx={{ width: '100%' }}>
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </>
    );
};

export default DeactivateUserDialog;
